<template>
  <div class="enterprise-list-page enterprise-list-page--services">
    <!-- Header Card -->
        <PageHeader icon="fas fa-hand-holding-medical">
      <template #title>
        Daftar Layanan Medis
      </template>
      <template #subtitle>
        Kelola tarif, produk, jenis tindakan, dan kategori layanan klinik
      </template>
      <template #actions>
        <b-button
                class="btn btn-primary font-weight-bold px-6 hc-btn-tambah-jadwal"
                @click="$router.push('/payment-categories/add')"
                v-if="btn">
                <i class="fas fa-plus"></i>
                <span>Tambah Layanan</span>
              </b-button>
      </template>
    </PageHeader>

    <!-- Component List -->
    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>
            <Table purpose="master" />
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "@/view/content/Card.vue";
import Table from "@/component/masters/payment-categories/Table.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  components: {
    Card,
    Table,
  },

  data() {
    return {
      btn: false,
      btnAddDoctorCommission: false,
    };
  },

  methods: {
    setActiveButton() {
      let access_right_user = window.localStorage.getItem(
        "access_right_display"
      );
      let access_right = JSON.parse(access_right_user);

      let a;
      for (a = 0; a < access_right.length; a++) {
        if (access_right[a] == "6009") {
          this.btn = true;
        }
      }
    },
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Daftar Layanan" },
      { title: "Layanan" },
    ]);
    this.setActiveButton();
  },
};
</script>
